import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import DatePickerInput from "@/components/DatePickerInput";

const PRESETS = [
  { key: "today", label: "Hari Ini" },
  { key: "yesterday", label: "Kemarin" },
  { key: "this_week", label: "Minggu Ini" },
  { key: "last_week", label: "Minggu Lalu" },
  { key: "this_month", label: "Bulan Ini" },
  { key: "last_month", label: "Bulan Lalu" },
];

export const MemberReportFilterBar = ({
  marketingFilter,
  setMarketingFilter,
  websiteFilter,
  setWebsiteFilter,
  followUpFilter,
  setFollowUpFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  marketingList,
  websiteList,
  followUpList,
  onApply,
  onReset,
  onPreset,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div className="space-y-2">
          <Label className="text-gray-300">Marketing</Label>
          <Select value={marketingFilter || "all"} onValueChange={(val) => setMarketingFilter(val === "all" ? "" : val)}>
            <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white">
              <SelectValue placeholder="Semua" />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
              <SelectItem value="all" className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white">Semua</SelectItem>
              {marketingList.map((m) => (
                <SelectItem key={m.id} value={m.name} className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white">
                  {m.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-gray-300">Website</Label>
          <Select value={websiteFilter || "all"} onValueChange={(val) => setWebsiteFilter(val === "all" ? "" : val)}>
            <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white">
              <SelectValue placeholder="Semua" />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
              <SelectItem value="all" className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white">Semua</SelectItem>
              {websiteList.map((w) => (
                <SelectItem key={w.id} value={w.name} className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white">
                  {w.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-gray-300">Follow Up</Label>
          <Select value={followUpFilter || "all"} onValueChange={(val) => setFollowUpFilter(val === "all" ? "" : val)}>
            <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white">
              <SelectValue placeholder="Semua" />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
              <SelectItem value="all" className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white">Semua</SelectItem>
              {followUpList.map((f) => (
                <SelectItem key={f.name} value={f.name} className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white">
                  {f.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="start-date" className="text-gray-300">Dari Tanggal</Label>
          <DatePickerInput
            id="start-date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-[#0f0f10] border-red-900/30 text-white"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="end-date" className="text-gray-300">Sampai Tanggal</Label>
          <DatePickerInput
            id="end-date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-[#0f0f10] border-red-900/30 text-white"
          />
        </div>
      </div>

      <div className="mt-4">
        <Label className="text-gray-300 mb-2 block">Preset Tanggal</Label>
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((p) => (
            <Button
              key={p.key}
              onClick={() => onPreset(p.key)}
              variant="outline"
              size="sm"
              className="border-red-900/30 text-white hover:bg-red-900/20"
            >
              {p.label}
            </Button>
          ))}
        </div>
      </div>

      <div className="flex gap-3 mt-4">
        <Button
          onClick={onApply}
          className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
          data-testid="apply-filter-button"
        >
          <Search className="mr-2" size={16} />
          Terapkan Filter
        </Button>
        <Button
          onClick={onReset}
          variant="outline"
          className="border-red-900/30 text-white hover:bg-red-900/20"
        >
          Reset
        </Button>
      </div>
    </>
  );
};

export default MemberReportFilterBar;
